module.exports = __webpack_public_path__ + "img/login-l.4cfd4e35.png";